import { render, staticRenderFns } from "./check-group.vue?vue&type=template&id=10f63679&scoped=true&"
import script from "./check-group.vue?vue&type=script&lang=js&"
export * from "./check-group.vue?vue&type=script&lang=js&"
import style0 from "./check-group.vue?vue&type=style&index=0&id=10f63679&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f63679",
  null
  
)

export default component.exports